import script from "./Candidates.vue?vue&type=script&setup=true&lang=js"
export * from "./Candidates.vue?vue&type=script&setup=true&lang=js"

import "./Candidates.vue?vue&type=style&index=0&id=56018368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56018368"]])

export default __exports__